/**
 * Section Header Component
 * Reusable header component with title and divider
 * Follows Single Responsibility Principle
 */

import React from 'react';
import { backgroundColors, spacing, borders } from '@/design-system/utils';
import { Heading } from './heading';

export interface SectionHeaderProps {
  title: string;
  backgroundColor?: string;
  /**
   * Whether to show background. Defaults to true.
   * When false, no background color is applied.
   */
  hasBackground?: boolean;
  className?: string;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  backgroundColor = '#fafaf9', // neutral-50 default
  hasBackground = true,
  className,
}) => {
  return (
    <div
      className={`${className || ''} md:gap-4`}
      style={{
        backgroundColor: hasBackground ? backgroundColor : 'transparent',
        borderRadius: hasBackground ? borders.radius.xl : 0,
        padding: spacing[3],
        display: 'flex',
        gap: spacing[2],
        alignItems: 'center',
      }}
    >
      <Heading as='h4'>{title}</Heading>
      <div
        style={{
          flex: 1,
          height: borders.width.thin,
          backgroundColor: backgroundColors.shade,
        }}
      />
    </div>
  );
};
